import React from "react";
import { useTranslation } from "react-i18next";

// Centered loading spinner with an accessible label.
//   <Spinner />            → block spinner + "Loading…" text
//   <Spinner small />      → compact version for cards/tables
const Spinner = ({ small = false, label, className = "" }) => {
  const { t } = useTranslation();
  const text = label || t("common.loading");
  return (
    <div
      className={`app-spinner d-flex align-items-center justify-content-center gap-2 text-muted ${small ? "py-2" : "py-5"} ${className}`}
      role="status"
      aria-live="polite"
    >
      <span
        className={`spinner-border text-danger ${small ? "spinner-border-sm" : ""}`}
        aria-hidden="true"
      />
      <span className={small ? "small" : ""}>{text}</span>
    </div>
  );
};

export default Spinner;
